import React, { Component } from 'react'
import { checkTranslation, translate } from '../../../../utils/useful'


class MessageSystemInfo extends Component {
    render() {
        let data = this.props.data
        if (data.systemInfo.type == 'topic') {
            return (
                <div className='w-100 flexcc'>

                    <p style={{ color: "#777", fontSize: 12, textAlign: "left" }}>{data.systemInfo.name + ' ' + translate('messenger.created')}</p>
                </div>
            )
        }
        else if (data.systemInfo.type == 'leave') {
            // console.log('data.systemInfo', data.systemInfo)
            return (
                <div className='w-100 flexcc'>
                    <p style={{ color: "#777", fontSize: 12, textAlign: "left" }}>{data.systemInfo.name + ' ' + translate('messenger.leaved')}</p>
                </div>
            )
        }
        else {
            return (
                <div className='w-100 flexcc'>

                    <p className='br-20 px-3 py-1' style={{ color: "#777", fontSize: 12, textAlign: "center",backgroundColor:'#f2f2f2' }}>{checkTranslation(data.systemInfo.name + ' ' + translate(data.systemInfo.type))}</p>
                </div>
            )
        }
    }
}

export default MessageSystemInfo;